// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__HiUnx","icon":"SortAdornment_icon__1dkP7","up":"SortAdornment_up__2k_2o","down":"SortAdornment_down__2UY_Z","active":"SortAdornment_active__1Urv9"};